import React, { useEffect, useState } from "react";
import useDocumentTitle from "./../Title/useDocumentTitle";

export default function Manutencao({ title }) {

  useDocumentTitle(title);
  return (
    <>
      <div className="side-app">
        <div className="main-container container-fluid">
          <div className="row mt-5">
            <div className="col-lg-12 col-sm-12">
              <div className="card overflow-hidden bg-info-transparent">
                <div className="card-body">
                  <div className="row">
                    <h1 className="page-title text-center">BET EM MANUTENÇÃO</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
